<template>
    <span class="DischargeEditor">
        <span v-if="OldEndDateFormatted != ''">
            {{ OldEndDateFormatted }}, {{ OldReason.Label }}
        </span>
        <span v-else>
            N/A
        </span>
        <font-awesome-icon :icon="['fa', 'edit']" v-if="EditMode && CheckPermission(EditPermission)" v-on:click="ShowEditModal()" class="pointer" />
        <b-modal ref="component-modal" v-bind:title="ModalTitle" @shown="HandleShown()" hide-footer>
            <b-container>
                <b-form @submit="DischargeClient">
                    <b-row>
                        <b-col>
                            <div class="form-group">
                                <label>Discharge Date:</label>
                                <flat-pickr v-model="NewEndDate" class="form-control" ref="showfocus" required :config="Config"></flat-pickr>
                            </div>
                            <div class="form-group">
                                <label>Discharge Reason:</label>
                                <select class="form-control" v-model="NewReason.Id" ref="showfocus" required>
                                    <optgroup v-for="optiongroup in OptionGroupings" :label="optiongroup">
                                        <option v-for="option in GetOptionsMatchingGrouping(optiongroup)" v-bind:value="option.value">
                                            {{ option.text }}
                                        </option>
                                    </optgroup>
                                    
                                    
                                </select>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row v-if="OldEndDateFormatted != ''">
                        <h3>Revert Closure</h3>
                        <p>NOTICE: This will reopen the case, and prior relationships that were ended due to the closure will be reopened.</p>
                        <b-button class="form-control" variant="warning" type="button" @click="RevertDischarge()">REVERT CLOSURE</b-button>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                SAVE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "OldEndDate",
            "OldReason",
            "RecordId",
            "RecordIdName",
            "EditMode",
            "DataLabel",
            "DischargeMethod",
            "RevertMethod",
            "Options",
            "DischargeLanguage",
            "SingularRecordUpdate",//bool
            "ChartId",
            "EditPermission"
        ],
        data: function () {
            return {
                NewEndDate: "",
                NewReason: {},
                Config: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                }
            };
        },
        methods: {
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            ShowEditModal() {
                this.NewEndDate = this.OldEndDateFormatted;
                if (this.OldEndDate != null) {
                    this.$set(this.NewReason, "Id", this.OldReason.Id);
                    this.$set(this.NewReason, "Label", this.OldReason.Label);
                } else {
                    this.$set(this.NewReason, "Id", "");
                    this.$set(this.NewReason, "Label", "");
                }
                
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            DischargeClient(e) {
                console.log(this.DischargeMethod);
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", this.DischargeMethod, { [this.RecordIdName === undefined ? "Id" : this.RecordIdName]: this.RecordId, EndDate: this.NewEndDate, DischargeReasonID: this.NewReason.Id }, this.DischargeClientSuccess, () => { }, true);
            },
            DischargeClientSuccess(response) {
                this.OldEndDate = this.NewEndDate;
                this.OldReason = {};
                            
                this.$refs['component-modal'].hide();
                this.$set(this.OldReason, "Id", this.NewReason.Id);
                this.$set(this.OldReason, "Label", this.NewReason.Label);
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            RevertDischarge() {
                this.$MasterAPI.ExecuteRequest("POST", this.RevertMethod, {  [this.RecordIdName === undefined ? "Id" : this.RecordIdName]: this.RecordId }, this.RevertDischargeSuccess, () => { }, true);
            },
            RevertDischargeSuccess(response) {
                this.$refs['component-modal'].hide();
                this.OldEndDate = null;
                this.OldReason = null;
                //Perform Global Updates
                this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            GetOptionsMatchingGrouping(groupingName) {
                return this.Options.filter(o => o.grouping == groupingName);
            },
            HandleShown() {
                //this.$refs.showfocus.$el.focus();
            }
        },
        components: {
            flatPickr
        },
        computed: {
            ModalTitle: function () {
                return this.DataLabel;
            },
            OldEndDateFormatted: function () {
                return this.formatDate(this.OldEndDate, "MM/DD/YYYY");
            },
            NewEndDateFormatted: function () {
                return this.formatDate(this.NewEndDate, "MM/DD/YYYY");
            },
            OptionGroupings: function () {
                let optGroupings = [];
                this.Options.map(function (key, index) {
                    if (!optGroupings.includes(key.grouping)) {
                        optGroupings.push(key.grouping);
                    }
                });
                return optGroupings;
            },
        }
    }
</script>

<style scoped>
</style>